export function linkToGetPremium() {
  return `/get-premium`;
}
